<template>
    <div class="bg-white px-3 index" style="margin: 0 26px;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                   
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="id" label="序号" width="50">
                </el-table-column>
                <el-table-column prop="name" label="奖池名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="describe" label="描述" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="奖品项" width="80">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handlelookqu(scope.$index, scope.row)">查看
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="80">
                    <template slot-scope="{row}">
                        <span>{{({1:'开启',2:'关闭'})[row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column prop="label" label="标签" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column label="操作" width="260">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!--  -->
        <el-dialog title="奖池设置" :visible.sync="dialogs" top="80px" width="50%" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-loading='editloading'>
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-row>
                        <el-form-item label="奖池名称" prop="name">
                            <el-input placeholder="请输入内容" size='small' v-model="form.name"> </el-input>
                        </el-form-item>
                        <el-form-item label="奖池描述" prop="describe">
                            <el-input type="textarea" :rows="2" placeholder="请输入" v-model="form.describe">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="总抽奖机会" prop="total_count">
                            <el-input type="number" style="max-width:250px;" size="small" placeholder="总抽奖次数限制次数，0则不限制"
                                v-model="form.total_count">
                            </el-input> 次
                        </el-form-item>
                        <el-form-item label="每日抽奖机会" prop="day_count">
                            每人每日有<el-input type="number" size="small" style="max-width:100px;margin:0 10px"
                                placeholder="请输入" v-model="form.day_count">
                            </el-input>次抽奖机会
                        </el-form-item>
                        <el-form-item label="消费积分" prop="consume">
                            <el-input placeholder="请输入" size='small' v-model="form.consume"> </el-input>
                        </el-form-item>
                        <el-form-item label="状态" prop="status">
                            <el-radio-group v-model="form.status">
                                <el-radio :label="1">开启</el-radio>
                                <el-radio :label="2">关闭</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="标签" prop="label">
                            <el-input placeholder="请输入" size='small' v-model="form.label"> </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :loading='subloading' @click="submit('form')" size="small">确 定
                            </el-button>
                            <el-button @click="dialogs = false" size="small">取 消</el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>
        <!-- 奖品-->
        <el-dialog title="奖品设置" :visible.sync="contentvotedetail" top="50px" width="60%" class="dialogs">
            <el-divider></el-divider>
            <Contentvotelist ref="votelist" />
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="contentvotedetail=false" size="small">确定</el-button>
            </span>
        </el-dialog>
        <!-- 预览图片 -->
        <el-dialog :visible.sync="previewModel" width="60vw" top="5vh">
            <div style="margin: -60px -20px -30px -20px;">
                <img :src="previewUrl" class="w-100" />
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import Contentvotelist from "./problems.vue";
    export default {
        components: {
            Contentvotelist
        },
        data() {
            return {
                dialog: false,
                titles: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                mtheights: {
                    height: null,
                    "overflow": "auto",
                },

                // 
                eid: '',
                props: {
                    label: 'problem',
                    children: 'children'
                },
                dialogs: false,
                form: {
                    name: '',
                    describe: '',
                    total_count: '',
                    day_count: '',
                    consume: '',
                    status: 1,
                    label:'',

                },
                rule: {
                    name: [{
                        required: true,
                        message: '问卷名称不能为空'
                    }],
                    describe: [{
                        required: true,
                        message: '请输入'
                    }],
                    total_count: [{
                        required: true,
                        message: '请输入'
                    }],
                    day_count: [{
                        required: true,
                        message: '请输入'
                    }],
                    consume: [{
                        required: true,
                        message: '请输入'
                    }],
                    status: [{
                        required: true,
                        message: '请选择'
                    }],
                    label: [{
                        required: true,
                        message: '请输入'
                    }],
                },
                fileListed: [],
                previewModel: false,
                previewUrl: '',
                contentvotedetail: false,
                editloading: false,
                subloading: false,
                category_id: '',

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                that.mtheights.height = window.innerHeight - 360 + 'px'

                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                    that.mtheights.height = window.innerHeight - 360 + 'px'

                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/wssadmin/prize/index", {
                        page: that.currentPage,
                        page_count: that.pagesize,

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list


                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },

            // 新增
            add() {
                let that = this
                that.dialogs = true
                that.eid = '0'
                that.clear()
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let urls;
                        if (that.eid && that.eid != '0') {
                            urls = "/admin/wssadmin/prize/update"
                        } else {
                            urls = "/admin/wssadmin/prize/save"
                        }
                        that.subloading = true
                        axios
                            .post(`${urls}`, {
                                ...this.form
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialogs = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                                that.subloading = false
                            })
                            .catch(error => {
                                that.subloading = false

                            })
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
            handleEdit(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.clear()
                this.editloading = true
                axios
                    .post("/admin/wssadmin/prize/read", {
                        id: that.eid
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        this.editloading = false
                        if (data) {
                           this.form=data
                        } else {
                            that.eid = ''
                        }
                    })
                    .catch(error => {})
            },
            handlelookqu(index, row) {
                this.contentvotedetail = true
                this.$nextTick(() => {
                    this.$refs.votelist.textId = row.id
                    this.$refs.votelist.getlist(row.id)
                    // this.$refs.votelist.votelist=row.content
                })
            },
            handleDelete(index, row) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/wssadmin/prize/del", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.search()
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            clear() {
                let that = this
                this.form = {
                    name: '',
                    describe: '',
                    total_count: '',
                    day_count: '',
                    consume: '',
                    status: 1,
                }
            },
        },

    };
</script>


<style scoped>
    .index {
        border-radius: 6px;
        padding-bottom: 10px;
    }

    .mr_ck {
        margin: 10px 0;
    }

    .f_w {
        font-weight: 600;
    }

    .bds {
        border-bottom: 1px solid #f5f5f5
    }

    .btn {
        margin-left: 20px;
    }
</style>